import React, { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ChartName from "../../Dashboard/Charts/ChartName";
import NoData from "../../Dashboard/Charts/NoData/NoData";
import { Dimmer, Loader, Icon } from "semantic-ui-react";
import { fetchRecommendationLists } from "../../../../actions/insightsRecommendationActions";
// import ChannelAnalysisChart from "../../Dashboard/Charts/ChannelAnalysis/ChannelAnalysisChart";
import ChannelBarChart from "../../Dashboard/Charts/ChannelAnalEngagementWise/ChannelBarChart";
import ChannelPieChart from "../../Dashboard/Charts/ChannelAnalEngagementWise/ChannelPieChart";
// import ChannelAnalysisBarChart from "../../Dashboard/Charts/ChannelAnalysis/ChannelAnalysisBarChart";
import moment from "moment";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import { QuestionLists } from "../HomePage/Header/InsightsTabComponent";

const PlatformSummary = () => {
    const dispatch = useDispatch();
    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const topic1Data = useSelector((state) => state.insightsRecommendationReducer.chartDataGPT?.["platform-summary"]?.own);
    const topic1DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoadingGPT);
    const topic2Data = useSelector((state) => state.insightsRecommendationReducer.chartData?.["platform-summary"]?.own);
    const topic2DataLoading = useSelector((state) => state.insightsRecommendationReducer.chartDataLoading?.["platform-summary"]?.own);
    const allPlatforms = useSelector((state) => state.filterSettingReducer.masterPlatforms);
    const currentPage = useSelector((state) => state.insightsRecommendationReducer.currentPage);

    let widgetContainerRef1 = useRef(null);

    const refreshData = () => {
        let param = {};
        param.topic_name = "own";
        param.chart_name = "platform-summary";

        dispatch(fetchRecommendationLists(param, "platform_summary", 1));
    };

    const getChannelAnalysisChart = (data, loading, ref, topic_name) => {
        let nodata = !data || (data && data.nodata);

        return (
            <>
                <div className={`dashboard-widget-container `} ref={ref}>
                    {!nodata ? (
                        <div className="dashboard-chart wordcloud-chart skiptranslate ">
                            <ChannelPieChart
                                data={data.data}
                                //   addContextMenuListener={this.addContextMenuListener}
                                allPlatforms={allPlatforms}
                                showLabel={false}
                                showLegendBar={true}
                                widgetContainerRef={ref}
                                insights__recommendation
                            />
                            <ChannelBarChart
                                data={data.data}
                                allPlatforms={allPlatforms}
                                showGridLines={true}
                                showLabel={true}
                                showLegendBar={false}
                                showLegend={false}
                                widgetContainerRef={ref}
                                insights__recommendation
                            />
                        </div>
                    ) : (
                        <>
                            <NoData classname="gpt__no__data" />
                        </>
                    )}
                </div>
            </>
        );
    };

    const getOverallSummaryChart = (data, loading, ref) => {
        let nodata = !data || (data && data.length === 0);
        data = data?.substring(0);
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let range = moment().tz(tz).subtract(7, "days").format("DD-MM-YYYY") + ` to ` + moment().tz(tz).subtract(1, "days").format("DD-MM-YYYY");
        let question = QuestionLists.find((obj) => obj.questionTab === currentPage)?.question || "";

        return (
            <>
                <div className={`dashboard-widget-container ${brandTopicObj}`} ref={ref}>
                    <div className="dashboard-widget-container-header skiptranslate ocr__owncloud">
                        <ChartName
                            name={"Platform Summary"}
                            info={`This section will provide you on how did your brand performed over different platforms `}
                            chatGPT={true}
                        />
                    </div>
                    <div className="gptHeader">
                        <div className="top">
                            <div>{question} </div>
                            <Popup content="Refresh" inverted size="mini" trigger={<Icon name="refresh" onClick={refreshData} />} position="top center" />
                        </div>
                        <div className="lower">{`From date: ${range}`}</div>
                    </div>
                    {loading || topic2DataLoading ? (
                        <div className="no__data__block">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                    ) : !nodata && !(loading || topic2DataLoading) ? (
                        <div className="dashboard-chart overall-summary-chart skiptranslate ">
                            {brandTopicObj ? getChannelAnalysisChart(topic2Data, topic2DataLoading, widgetContainerRef1, "topic 1") : null}
                            <pre>{data}</pre>
                        </div>
                    ) : (
                        <>
                            <NoData classname="gpt__no__data" />
                        </>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            <div className={`ocr__wordcloud__wrapper`}>{brandTopicObj ? getOverallSummaryChart(topic1Data, topic1DataLoading, widgetContainerRef1) : null}</div>
        </>
    );
};

export default PlatformSummary;
